import { render, staticRenderFns } from "./profitItem.vue?vue&type=template&id=7b1a8e88&scoped=true&"
import script from "./profitItem.vue?vue&type=script&lang=js&"
export * from "./profitItem.vue?vue&type=script&lang=js&"
import style0 from "./profitItem.vue?vue&type=style&index=0&id=7b1a8e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1a8e88",
  null
  
)

export default component.exports